import { CSSProperties } from 'react';

export const ellipsisStyling = { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } as CSSProperties;
